import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, TableCell, TableRow } from '@material-ui/core';
import { toNaira } from 'src/utils/helper';
import formatPrice from 'src/utils/formatPrice';
import TripStatus from 'src/components/TripStatus';

const useStyles = makeStyles(() => ({
  nowrap: {
    whiteSpace: 'nowrap'
  }
}));

const TransactionRow = ({ transaction }) => {
  const classes = useStyles();
  const {
    amount,
    amountCurrency,
    transactionStatus,
    transactionType,
    balance,
    previousBalance,
    summary
  } = transaction;
  return (
    <TableRow>
      <TableCell>{transactionType === 'DR' ? 'DEBIT' : 'CREDIT'}</TableCell>
      <TableCell className={classes.nowrap}>
        {formatPrice(previousBalance, amountCurrency, toNaira)}
      </TableCell>
      <TableCell className={classes.nowrap}>
        {formatPrice(amount, amountCurrency, toNaira)}
      </TableCell>
      <TableCell className={classes.nowrap}>
        {formatPrice(balance, amountCurrency, toNaira)}
      </TableCell>
      <TableCell size="smalls">
        <TripStatus status={transactionStatus} />
      </TableCell>
      <TableCell>{summary}</TableCell>
    </TableRow>
  );
};

TransactionRow.propTypes = {
  transaction: PropTypes.object
};

export default TransactionRow;
